// src/api/material/meta.js
import api from "../axios";

// --------------------------------------
// save_full (material 전용, doc_type 기반)
// --------------------------------------
export async function saveFullMaterialDoc({
  project,
  module = "material",
  doc_type, // 🔥 필수
  title = "",
  header = {},
  lines = [],
  dns = null,
  level2 = "GEN",
  status = null, // 🔥 추가: 시공사 불합격 시 rejected 전달
}) {
  if (!project) throw new Error("project is required");
  if (!doc_type) throw new Error("doc_type is required");

  const payload = {
    project,
    module,
    doc_type, // 🔥 PO / GR / GI
    title,
    header, // 🔥 meta 아님
    lines, // 🔥 meta 아님
    dns,
    level2,
    status, // 🔥 추가
  };

  console.log("🔥 saveFullMaterialDoc payload:", payload);

  const res = await api.post(`/material/docs/save_full/`, payload);
  return res.data;
}

// --------------------------------------
// CREATE (FormContentManager)
// --------------------------------------
export async function createMeta(values, project) {
  const {
    module = "material",
    doc_type,
    title = "",
    header = {},
    lines = [],
    level2 = "GEN",
    status = null, // 🔥 추가: 시공사 불합격 시 rejected 전달
  } = values || {};

  return await saveFullMaterialDoc({
    project,
    module,
    doc_type,
    title,
    header,
    lines,
    level2,
    dns: null,
    status, // 🔥 추가
  });
}

// --------------------------------------
// UPDATE
// --------------------------------------
export async function updateMeta(dns, values, project) {
  const {
    module = "material",
    doc_type,
    title = "",
    header = {},
    lines = [],
    level2 = "GEN",
    status = null, // 🔥 추가
  } = values || {};

  return await saveFullMaterialDoc({
    project,
    module,
    doc_type,
    title,
    header,
    lines,
    level2,
    dns,
    status, // 🔥 추가
  });
}

// --------------------------------------
// GET
// --------------------------------------
export async function getMaterialDoc({ dns, project }) {
  const res = await api.get(`/material/docs/detail/${dns}/`, {
    params: { project },
  });
  return res.data;
}
